import { MatGoogleMapsAutocompleteDirective } from '@angular-material-extensions/google-maps-autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  OnChanges,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioGroup } from '@angular/material/radio';
import { Router } from '@angular/router';
import { Carrier } from '@app/services/carriers/carrier.model';
import { ECOMMERCES, Shop } from '@app/services/shops/shop.model';
import { ShopService } from '@app/services/shops/shop.service';
import { CheckoutService } from '@pages/checkout-app/checkout.service';
import { ErrorDialog } from '@pages/checkout-app/components/dialogs/error-dialog/error-dialog';
import { PolygonFetchCitiesDialog } from '@pages/checkout-app/components/dialogs/polygon-fetch-cities-dialog/polygon-fetch-cities-dialog';
import { PolygonSuccessDialog } from '@pages/checkout-app/components/dialogs/polygon-success-dialog/polygon-success-dialog';
import { Polygon } from '@pages/checkout-app/components/polygon/polygon';
import {
  configFormFields,
  countryList,
  customDeliveryPromiseValidator,
  customSLAValidator,
  customDisplayDeliveryPromisePDQIQValidator,
  delieryDaysNTimeConfig,
  deliveryMethodTypeValidatorFactory,
  deliveryTypeBtnConfig,
  GEODeliveryAreaConfig,
  GEODeliveryAreaZipCodesConfig,
  NonUseFullControls,
  RequiredFormControlsMap,
} from '@pages/checkout-app/configs';
import { CalendarService, FormService } from '@pages/checkout-app/services';
import { CanDeactivateGuard } from '@pages/checkout-app/shared/deactivate-guard/deactivate-gurad';
import {
  AdditionalPriceRanges,
  Address,
  CityValues,
  DeliveryDaysNTime,
  DeliveryPromise,
  fieldsConfig,
  Options,
  RadioButtonsConfig,
  ShipmentExtras,
  ShippingMethods,
  Shippings,
  ShopLocations,
  ShopSettings,
} from '@pages/checkout-app/types';
import {
  GEODeliveryArea,
  GEODeliveryAreaConst,
  GEODeliveryAreaMethod,
  internationalMethods,
  Latlng,
  ShippingMethod,
} from '@pages/checkout-app/types/types';
import {
  CHECKOUT_URL,
  convertCondition,
  DISTANCE_UNITS,
  formattedServiceLevelTime,
  getTwentyFourHourTime,
  initShopSettings,
} from '@pages/checkout-app/utils';
import { ConditionComponent } from '@pages/checkout-app/components/sections/conditions/condition.component';
import { ItemFeeRulesComponent } from '@pages/checkout-app/components/fee-per-item/item-fee-rules/item-fee-rules.component';
import { ItemFeeSetupStateService } from '@pages/checkout-app/services/item-fee-setup-state.service';
import { fromUnmatchedFee } from '@pages/checkout-app/components/fee-per-item/unmatched-fee.util';
import {
  feePerItemForSave,
  normaliseFeePerItem,
} from '@pages/checkout-app/components/fee-per-item/fee-per-item-payload.util';
import { FeePerItemComponent } from '../../../../../components/fee-per-item/fee-per-item.component';
import {
  CountryCode,
  countryCodeToDisplayNameMap,
  countryCodeToStates,
  extendedCountryToStates,
} from '@pdqdev/pdq-shared/dist/utils/Country-utils';
import * as turfBoolean from '@turf/boolean-point-in-polygon';
import { merge, Observable, of, Subject, Subscription } from 'rxjs';
import { auditTime, catchError, filter, finalize, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { ChangeReviewService } from '@app/sharedModule/change-review/change-review.service';
import { ChangeReviewConfig } from '@app/sharedModule/change-review/change-review.model';
import { UnsavedChangesTracker } from '@app/sharedModule/change-review/unsaved-changes-tracker';
import { diffChanges } from '@app/sharedModule/change-review/change-review.utils';
import { StaleSaveService } from '@app/sharedModule/change-review/stale-save.service';
import {
  buildShippingMethodReviewConfig,
  describeRule,
  SHIPPING_ENTITY_PATHS,
  inertFeeFeatures,
} from './shipping-method-review.config';
import { AREA_LIST_FIELDS, LOCATIONS_CONDITION, ScheduleDay } from './shipping-method-review.model';
import { LayoutService } from '@app/storybook/services/layout/layout.service';
import {
  buildConditionControl,
  buildPriceTierControl,
  isEmptyConditionRow,
  isFilledConditionGroup,
  ShippingMethodRevert,
} from './shipping-method-revert';
import { DropdownOption } from '@storybook/components/dropdown/dropdown.component';
import { ICheckoutVariantABTest, Checkout, ICheckoutEstimatedTimeConversion } from '@pdqdev/pdq-shared/dist/interfaces';
import { OrderEvents } from '@services/order/order.model';
import { AbtestDialogComponent } from '@pages/checkout-app/components/abtest/dialogs/abtest-dialog/abtest-dialog.component';
import { ACTIONS } from '@pages/checkout-app/components/abtest/models';
import { CheckoutActions } from '@pages/checkout-app/checkout-store/actions';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { ToastService } from '@storybook/services/toast/toast.service';
import { formatAddress } from '@utils/address-utils';
import { stripHtmlTags } from '@utils/string-utils';
import {
  buildZonesOriginAddressFromShippedFromLocation,
  findShippedFromLocation,
  isZonesOriginAddressAutoFilledFromShippedFromLocation,
  ZonesOriginAddress,
} from '@pages/checkout-app/utils/shop.utils';
import * as fromCheckoutReducer from '@pages/checkout-app/checkout-store/reducers/checkout.reducer';
import { PdqRadioGroupComponent } from '@app/storybook/components/radio-button-group/radio-group/radio-group.component';
import { RulesDynamicFormService } from '@app/sharedModule/components/rules-dynamic-form/rules-dynamic-form.service';
import { DeliveryPromiseRestrictionRules } from '@pages/checkout-app/components/sections/delivery-promise/delivery-promise-restrictions/config';
import { ConfirmationDialogComponent } from '@app/sharedModule/components/confirmation-dialog/confirmation-dialog.component';
import { TYPO_MAP } from './utils/abbrevationTypoMap';
import { ABBREVIATION_MAP } from './utils/abbrevationTypoMap';

const DEFAULT_ZONES_PLACEHOLDER = 'select your zones';

@Component({
  selector: 'app-checkout-app',
  templateUrl: './checkout.app.component.html',
  styleUrls: ['./checkout.app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CheckoutAppComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild(Polygon) polygonCmp: Polygon;
  @ViewChild(ConditionComponent) shippingRulesEditor?: ConditionComponent;

  @ViewChild('localModeCityAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  localModeCityAutocomplete: MatGoogleMapsAutocompleteDirective;
  @ViewChild('citiesListMethodAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  citiesListMethodAutocomplete: MatGoogleMapsAutocompleteDirective;
  @ViewChild('excludedCitiesListMethodAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  excludedCitiesListMethodAutocomplete: MatGoogleMapsAutocompleteDirective;
  @ViewChild('excludedStatesListMethodAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  excludedStatesListMethodAutocomplete: MatGoogleMapsAutocompleteDirective;
  @ViewChild('addressAndRadiusMethodAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  addressAndRadiusMethodAutocomplete: MatGoogleMapsAutocompleteDirective;

  @ViewChild('listedStatesMethodAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  listedStatesMethodAutocomplete: MatGoogleMapsAutocompleteDirective;
  @ViewChild('listedCitiesMethodAutocomplete', {
    read: MatGoogleMapsAutocompleteDirective,
  })
  listedCitiesMethodAutocomplete: MatGoogleMapsAutocompleteDirective;

  @ViewChild('geoDeliveryAreaMethod') geoDeliveryAreaMethod: MatRadioGroup;
  @ViewChild('geoSettingsRadio') geoSettingsRadio: PdqRadioGroupComponent;

  @Input() isLoading: boolean = false;
  @Input() loadValues: Shippings;
  @Input() editMode: boolean = false;
  @Input() isDuplicate = false;
  updatesExistingMethod = false;
  @Output() submitForm = new EventEmitter<Shippings>();

  readonly CountryCodes = CountryCode;
  readonly ShippingMethod = ShippingMethod;
  readonly GEODeliveryAreaMethod = GEODeliveryAreaMethod;
  readonly GEODeliveryArea = GEODeliveryArea;
  readonly GEODeliveryAreaConst = GEODeliveryAreaConst;
  readonly GEODeliveryAreaConfig: RadioButtonsConfig[] = [...GEODeliveryAreaConfig];
  readonly requiredFormControlsMap = RequiredFormControlsMap;
  readonly nonUseFullControls: string[] = [...NonUseFullControls];
  readonly googleCalendarIdsList: Options[] = [...countryList()];
  readonly deliveryDaysNTimeConfig: DeliveryDaysNTime[] = [...delieryDaysNTimeConfig];
  readonly deliveryTypeBtnConfig = [...deliveryTypeBtnConfig];
  readonly zipCodesOperatorsConfig = [...GEODeliveryAreaZipCodesConfig];
  readonly configFormFields = [...configFormFields];
  readonly googleAutoCompleteOptions = {
    fields: ['geometry', 'address_components', 'types', 'formatted_address'],
  };
  countriesOptions: string[] = Object.keys(countryCodeToDisplayNameMap);

  readonly zipCodesMaxTextLength = 100000;

  zoneOptions: Options[];
  polygonRadiusUnits: DISTANCE_UNITS = DISTANCE_UNITS.MILES;
  shopSettings: ShopSettings = {};
  shopPlatform: ECOMMERCES;
  shopLocations: Array<ShopLocations> = [];
  shippedFromAddress: Address;
  showFormErrors: boolean = false;
  editableCheckout: Shippings;
  formGroup: UntypedFormGroup;
  shipmentExtrasFormGroup: UntypedFormGroup;
  loadedCarrier: Carrier;
  shipmentExtras: ShipmentExtras;
  shop: Shop;
  deliveryType: string;
  private _shippingMethodCategory: ShippingMethod;
  get shippingMethodCategory(): ShippingMethod {
    return this._shippingMethodCategory;
  }
  set shippingMethodCategory(value: ShippingMethod) {
    this._shippingMethodCategory = value;
    this.checkoutService.setShippingMethodCategory(value ?? null);
  }
  shippingMethodDetail: ShippingMethods;
  stepOne: string;
  stepTwo: string;
  stepThree: boolean = false;
  showExpansionGuide: any;
  accordionActiveSection: string[] = [];
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectedAddressForZonesTypeControl = new UntypedFormControl(null);
  getCitiesControl = new UntypedFormControl();
  excludedCitiesControl = new UntypedFormControl();
  listedStatesControl = new UntypedFormControl();
  listedCitiesControl = new UntypedFormControl();
  excludedStatesControl = new UntypedFormControl();
  selectedCities: string[] = [];
  excludedCities: string[] = [];
  excludedStates: string[] = [];
  listedStates: string[] = [];
  listedCities: string[] = [];
  polygonRadius: number;
  maxPolygonRadius: number;
  polygonAddress: string = '';
  showPenToolToolTip: boolean = false;
  isLoadingData: boolean = false;
  polygonCities: [] = [];
  polygonLatLngs: [] = [];
  polygonInputValues: Array<any> = [];
  renderPolygon: boolean = true;
  loadedPolygonStage: string;
  isCheckoutFormInvalid: boolean = false;
  isSaving = false;
  readonly changeTracker = new UnsavedChangesTracker<Shippings>(
    () => this.buildPayload(),
    (baseline) => this.buildReviewConfig(baseline),
  );

  selectedOnDrawerMode: any;

  selectValueFromPolygonAutocompleteCoors: any = [];
  editableCheckoutName: string;
  agreementFileURL: string;
  localMethodCityChoose: CityValues = {
    name: '',
  };
  localCountySelected: CityValues = {
    name: '',
  };
  localCityBoundary: any;
  tooltipPositionCalc = '730px;';
  deliveryAreaMethodRadioGroup: string | null;
  currentMethodStage: string;
  disableApply: boolean = true;
  zonesOriginAddress: ZonesOriginAddress;
  zonesPlaceholder: string = DEFAULT_ZONES_PLACEHOLDER;
  invalidMessage: string | undefined = undefined;
  zipCodesLength = 1000000;
  destroy$ = new Subject();
  countryCodeToDisplayNameMap = countryCodeToDisplayNameMap;
  countriesToAskForState = Object.keys(countryCodeToStates);
  runningABTest: ICheckoutVariantABTest = null;
  editRunningABTest: MatDialogRef<AbtestDialogComponent>;
  linkedDatePickerExtension$ = this.store.select(fromCheckoutReducer.linkedDatePickerExtensions);
  multiShipDatePickerExtension$ = this.store.select(fromCheckoutReducer.multiShipDatePickerExtensions);

  private deliveryMethodSectionNames: Record<string, string> = {};
  private openedEntity: Shippings;
  private unsavedChangesSubscription?: Subscription;
  private reviewInProgress = false;
  private readonly revert = new ShippingMethodRevert(this, {
    describeRule: (rule, money) => describeRule(rule, convertCondition, money),
    sectionNames: () => this.deliveryMethodSectionNames,
    setCurrency: (currency) => (this.checkoutService.shippingMethodCurrency = currency),
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastService,
    private shopService: ShopService,
    private router: Router,
    private dialog: MatDialog,
    private store: Store<fromCheckoutReducer.State>,
    private calendarService: CalendarService,
    private deactivateGuard: CanDeactivateGuard,
    private checkoutService: CheckoutService,
    private actions: Actions,
    private dynamicRulesService: RulesDynamicFormService,
    private changeReview: ChangeReviewService,
    private formService: FormService,
    private staleSave: StaleSaveService,
    private layoutService: LayoutService,
    private itemFeeSetupState: ItemFeeSetupStateService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {}

  detectFailure() {
    this.actions
      .pipe(takeUntil(this.destroy$), ofType(CheckoutActions.editRunningABTestFailure))
      .subscribe((result) => {
        this.toastService.showToast({
          message: result.errorMessage,
          mode: 'danger',
        });
      });
  }

  detectSuccess() {
    this.actions
      .pipe(takeUntil(this.destroy$), ofType(CheckoutActions.editRunningABTestSuccess))
      .subscribe((result: any) => {
        if (result.shipping) {
          this.store.dispatch(CheckoutActions.loadCheckouts());
          this.toastService.showToast({
            message: result.type,
            mode: 'info',
          });
        }
        this.editRunningABTest?.close();
        this.deactivateGuard.onSubmit(true);
        this.router.navigate([`${CHECKOUT_URL}`]);
      });
  }

  onDeliveryMethodSectionsLoaded(options: DropdownOption[]): void {
    this.deliveryMethodSectionNames = Object.fromEntries(options.map((option) => [option.value, option.label]));
  }

  detectEditSuccess() {
    this.actions
      .pipe(ofType(CheckoutActions.editCheckoutSuccess, CheckoutActions.editCheckoutFailure), takeUntil(this.destroy$))
      .subscribe(() => (this.isSaving = false));

    this.actions
      .pipe(
        ofType(CheckoutActions.editCheckoutSuccess),
        // false for saves that didn't go through the review (create, duplicate)
        filter(() => this.changeTracker.markSaved()),
        switchMap(({ updatedAt }) => {
          this.editableCheckoutName = this.changeTracker.baseline.name;
          // our own save must not look like someone else's, even if the reload below fails
          this.openedEntity = { ...this.openedEntity, updatedAt };
          return this.formService.loadCheckoutById(this.openedEntity?.id).pipe(catchError(() => of(null)));
        }),
        takeUntil(this.destroy$),
      )
      .subscribe((latest) => {
        if (latest) this.openedEntity = latest;
      });
  }

  get deliveryPromiseDontCalculateOnFields(): UntypedFormArray {
    return this.formGroup.get('deliveryPromiseDontCalculateOn') as UntypedFormArray;
  }

  get additionalPriceRanges(): UntypedFormArray {
    return this.formGroup.get('additionalPriceRanges') as UntypedFormArray;
  }

  get blackoutDaysField(): UntypedFormArray {
    return this.formGroup.get('customBlackoutDates') as UntypedFormArray;
  }

  get deliveryDaysAndTimes(): UntypedFormArray {
    return this.formGroup.get('deliveryDaysAndTimes') as UntypedFormArray;
  }

  get conditionsField(): UntypedFormArray {
    return this.formGroup.get('conditions') as UntypedFormArray;
  }

  async ngOnInit(): Promise<void> {
    this.layoutService.headerBackAction$.set(() => this.onDiscard());
    this.layoutService.headerBackIconOnly$.set(true);
    //pre-setup for shippings delivery type only
    this.detectSuccess();
    this.detectFailure();
    this.detectEditSuccess();
    // The linked-calendar / multi-ship date-picker dropdowns read extensions from the store,
    // which otherwise only loads on the /convert/extensions route — load it here too.
    this.store.dispatch(CheckoutActions.loadExtensionsListLightweight());
    this.deliveryType = 'shippings';
    this.stepOne = 'shippings';
    this.initShopSettings();
    this.initScrollEvent();
    this.zoneOptions = this.generateZipCodesOptions();
    this.initCarrierChange();
    this.initListedStatesControlSubscription();
  }
  initListedStatesControlSubscription(): void {
    this.listedStatesControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (value && typeof value === 'object') {
        this.setLocationSettingsValues({ listedStatesControl: value });
      }
    });
  }
  initCarrierChange() {}

  handleZipCodesSelect(data?: { operator: Checkout.DeliveryAreaZipCodesOperator }) {
    const state = this.formGroup.get('international.deliveryAreaZipCodes').value || {};
    state.operator = data.operator;
    this.formGroup.get('international.deliveryAreaZipCodes').patchValue(state);
  }

  initScrollEvent(): void {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  ngOnDestroy() {
    this.layoutService.headerBackAction$.set(null);
    this.layoutService.headerBackIconOnly$.set(false);
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  get geoSettingsOriginAddress(): ShopLocations {
    return findShippedFromLocation(this.shopSettings.locations, this.formGroup.get('shippedFromLocation').value);
  }

  get geoSettingsOriginCountry(): string {
    return this.geoSettingsOriginAddress?.country;
  }

  get geoSettingsOriginCountryCode(): string {
    return this.geoSettingsOriginAddress?.countryCode;
  }

  scrollEvent = (): void => {
    // check if container exists
    // google mat auto complete scrolling issue!
    // display none on all container node list
    if (
      this.localModeCityAutocomplete ||
      this.citiesListMethodAutocomplete ||
      this.addressAndRadiusMethodAutocomplete
    ) {
      const container: any = this._document.querySelectorAll('div.pac-container');
      if (container) {
        for (let i = 0; i < container.length; i++) {
          container[i].style.display = 'none';
        }
      }
    }
  };

  ngAfterViewInit(): void {}

  initShopSettings(): any {
    this.shopService.shop$.pipe(takeUntil(this.destroy$)).subscribe((shop: Shop) => {
      if (!shop) {
        return;
      }
      this.shop = shop;
      const shopSettingsO = initShopSettings(shop);
      this.checkoutService.initialShopSettingsSubject.next(JSON.parse(JSON.stringify(shopSettingsO)));
      this.shopSettings = shopSettingsO;
      this.shopPlatform = this.shop?.platform;
      this.checkoutService.shippingMethodCurrency = shopSettingsO.shopCurrency;
      this.initForm();
    });
  }

  initOnEditModeOpenAccordions(): void {
    this.configFormFields.map((field) => {
      if (field && field.type == 'array' && field.section) {
        const array = this.formGroup.get(field.fieldName) as UntypedFormArray;
        if (array.length > 0) {
          if (!this.accordionActiveSection.includes(field.section)) {
            this.accordionActiveSection.push(field.section);
          }
        }
      } else {
        const value = this.getField(field.fieldName).value;
        if (value != field.defaultValue && field.section) {
          if (!this.accordionActiveSection.includes(field.section)) {
            this.accordionActiveSection.push(field.section);
          }
        }
      }
    });
  }

  onSelectDeliveryAreaMethod(event): void {
    this.selectedCities = [];
    // able to save without apply on listed states
    this.isCheckoutFormInvalid = true;
    if (event?.value == GEODeliveryAreaMethod.LISTED_STATES || event?.value == GEODeliveryAreaMethod.LISTED_CITIES) {
      this.showPenToolToolTip = false;
      this.isCheckoutFormInvalid = false;
      return;
    }

    // init input as shop primary location if user not choose any
    this.polygonAddress = this.shopSettings.primaryLocation;

    this.polygonRadiusUnits = DISTANCE_UNITS.MILES;
    if (this.shopSettings.shopCountyCode === CountryCode.IL) {
      this.polygonRadiusUnits = DISTANCE_UNITS.KILOMETERS;
    }

    this.selectValueFromPolygonAutocompleteCoors = [];
    this.polygonCmp.onSelectPolygonMethodChange(event);

    this.setLocationSettingsValues({}, true);
  }

  onPolygonRadiusUnitsChange({ value: units }): void {
    this.polygonRadiusUnits = units;
  }

  onApplyGeo(event, isApplyClicked?: boolean): void {
    // we must apply to save checkout if we select some method
    this.isCheckoutFormInvalid = false;
    // reset listedStates and listedCities on polygon apply click
    this.listedStates = [];
    this.listedCities = [];

    if (!event) {
      this.dialog.open(PolygonSuccessDialog, {
        data: {
          msg: `Please, Choose Method`,
        },
      });
    } else {
      const isValid = this.geoInputValidation(event);
      if (isValid) {
        this.isLoadingData = true;
        event.includes('from_address_radius')
          ? (this.selectValueFromPolygonAutocompleteCoors = {
              ...this.selectValueFromPolygonAutocompleteCoors,
              address: this.polygonAddress,
              radius: +this.polygonRadius, // as min radius
              maxRadius: +this.maxPolygonRadius, // as max radius
              radiusUnits: this.polygonRadiusUnits,
            })
          : '';

        this.polygonCmp.onApplyGeo(
          event,
          this.shippingMethodCategory,
          this.selectValueFromPolygonAutocompleteCoors,
          isApplyClicked,
        );
      } else {
        // delivery area method selection is not valid, prevent from save
        this.isCheckoutFormInvalid = true;
      }
    }
  }

  geoInputValidation(event: string): boolean {
    let result: boolean = true;
    let errorMessage: string | null = null;
    switch (event) {
      case 'cities_from_list':
      case 'states_from_list':
      case 'streets_from_list': {
        if (this.selectedCities.length < 3) {
          errorMessage = `Enter at least 3 ${this.getCitiesStatesStreetsText()} to get a list of the ${this.getCitiesStatesStreetsText()} within that area.`;
        }
        break;
      }
      case 'cities_from_address_radius':
      case 'states_from_address_radius':
      case 'streets_from_address_radius': {
        if (this.polygonAddress?.length < 1) {
          errorMessage = 'Please enter valid address';
        }
        if (this.maxPolygonRadius == null || this.polygonRadius == null) {
          errorMessage = 'Please set maximum radius and minimum radius';
        }
        if (this.maxPolygonRadius <= 0) {
          errorMessage = 'Please set a valid maximum radius, greater then 0';
        }
        if (this.maxPolygonRadius > 0 && this.polygonRadius == null) {
          errorMessage = 'Please set valid minimum radius, greater then 0';
        }
        if (this.shippingMethodCategory === ShippingMethod.LOCAL && this.polygonRadius != 0) {
          errorMessage = 'Please set minimum radius to be 0, on this local method';
        }
        if (this.polygonRadius && this.maxPolygonRadius && this.polygonRadius > this.maxPolygonRadius) {
          errorMessage = 'Please set valid radius, maximum radius must be higher or equals to minimum radius';
        }
        break;
      }

      default: {
        return (result = true);
      }
    }

    if (errorMessage) {
      this.dialog.open(PolygonSuccessDialog, {
        data: {
          msg: errorMessage,
        },
      });
      result = false;
    }

    return result;
  }

  onShowPolygonPenToolTip(event): void {
    this.showPenToolToolTip = event;
  }

  onLoading(loading: boolean): void {
    this.isLoadingData = loading;
  }

  onInvalidDraw(isDrawValid: boolean = false) {
    this.isCheckoutFormInvalid = isDrawValid;
  }

  setLocationSettingsValues(values: any = {}, resetValues: boolean = false): void {
    if (values?.cities) {
      this.polygonCities = values.cities;
    }

    if (resetValues) {
      this.formGroup.patchValue({ polygonInputValues: [{}] });
      return;
    }

    if (this.shippingMethodCategory == ShippingMethod.LOCAL) {
      values = { ...values, localMethodCityChoose: this.localMethodCityChoose };
    }
    const polygonCurrentValues = this.formGroup.get('polygonInputValues');
    const updatedPolygonValues = Object.assign({
      ...polygonCurrentValues?.value[0],
      ...values,
    });

    this.formGroup.patchValue({ polygonInputValues: [updatedPolygonValues] });
  }

  onDrawerButtonClick(event): void {
    this.showPenToolToolTip = event;
  }

  onLocalCityBoundaryCreates(cityValue): void {
    this.localCityBoundary = cityValue;
  }

  // local method, default city full name
  onUpdateLocalCityName(cityValue: CityValues): void {
    this.localMethodCityChoose = cityValue;
    this.changeTracker.refresh();
  }

  fetchCitiesDialog(): void {
    if (this.polygonCities?.length > 0) {
      const selectedMethod: string = this.getField('geoDeliveryAreaMethod')?.value;
      this.dialog.open(PolygonFetchCitiesDialog, {
        data: {
          citiesCount: this.polygonCities,
          category: this.shippingMethodCategory,
          selectedMethod,
        },
      });
    } else {
      this.dialog.open(PolygonSuccessDialog, {
        data: {
          msg: `To get the list of ${this.getCitiesStatesStreetsText()} in your delivery zone, first select a method and create your zone and select Apply.`,
        },
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loadValues) {
      if (this.loadValues && this.editMode) {
        this.initLoadedShippingMethodValues();
      }
    }
  }

  initLoadedShippingMethodValues() {
    this.updatesExistingMethod = !this.isDuplicate;
    this.shippingMethodCategory = this.loadValues?.shippingMethod?.category;
    this.shippingMethodDetail = this.loadValues?.shippingMethod;
    this.initForm();
    this.editableCheckoutName = this.loadValues.name;
    this.runningABTest = this.getRunningABTest(this.loadValues?.variants);
    // setCheckoutValue mutates its input
    this.openedEntity = cloneDeep(this.loadValues);
    this.setCheckoutValue(this.loadValues);
    // one tick, so section components apply their init defaults first
    setTimeout(() => {
      this.changeTracker.start();
    });
  }

  onSelectAddressAndRadius(event) {
    this.selectValueFromPolygonAutocompleteCoors = {
      lat: event.latitude,
      lng: event.longitude,
    };
  }

  onCityAdd(event: any): void {
    let value = (event.name || '').trim();
    const geoDeliveryArea: any = this.getField('geoDeliveryArea')?.value;

    // to show full street name without cutoff
    if (event.types && event.types[0] === 'street_address') {
      value = `${event.address_components[0].long_name} ${event.address_components[1].long_name}`;
    }

    /** TO DO - false case is point as cities, refactor needed **/
    if (event.types && geoDeliveryArea === false && this.shippingMethodCategory !== ShippingMethod.LOCAL) {
      value = event.address_components.find(
        (component) => component.types.includes('locality') || component.types.includes('sublocality'),
      )?.long_name;
    }

    // case states
    if (event.types && geoDeliveryArea === 'states') {
      value = event.address_components.find((component) =>
        component.types.includes('administrative_area_level_1'),
      )?.long_name;
    }

    if (value) {
      // case we in local streets mode
      if (this.shippingMethodCategory == 'local') {
        const point: [number, number] = [event.geometry.location.lat(), event.geometry.location.lng()];
        const isPointInsidePolygon = turfBoolean.default(point, this.localCityBoundary);
        if (!isPointInsidePolygon) {
          this.dialog.open(ErrorDialog, {
            data: {
              msg: `Please, make sure you enter right street address for selected city`,
            },
          });
          return;
        }
      }

      const locationPoint: Latlng = {
        lat: event.geometry.location.lat(),
        lng: event.geometry.location.lng(),
      };

      const isTargetValueInSelectedCities: boolean = this.selectedCities.some((val) => val === value);

      if (!isTargetValueInSelectedCities) {
        this.selectedCities.push(value);
        this.selectValueFromPolygonAutocompleteCoors.push(locationPoint);
      }
    }

    this.getCitiesControl.setValue('');
    this.citiesListMethodAutocomplete.elemRef.nativeElement.value = '';
  }

  onListedCity(event: any): void {
    let value;

    if (event.types && event.address_components) {
      value = event.address_components.find(
        (component) => component.types.includes('locality') || component.types.includes('sublocality'),
      )?.long_name;
    }

    if (typeof value !== 'string' || value?.trim() === '') {
      return;
    }

    const isTargetValueInListedCities: boolean = this.listedCities.some((val) => val === value);

    if (!isTargetValueInListedCities) {
      this.listedCities.push(value);
    }

    this.listedCitiesControl.setValue('');
    this.listedCitiesMethodAutocomplete.elemRef.nativeElement.value = '';
    this.changeTracker.refresh();
  }

  onListedCityRemove(city: string, index: number): void {
    if (index >= 0) {
      this.listedCities.splice(index, 1);
    }
    this.changeTracker.refresh();
  }

  onExcludedStateRemove(index: number): void {
    if (index >= 0) {
      this.excludedStates.splice(index, 1);
    }
    this.changeTracker.refresh();
  }

  onExcludeStateAdd(event: any): void {
    let value = (event.name || '').trim();
    // get only state name
    if (event.types) {
      value = event.address_components.find((component) =>
        component.types.includes('administrative_area_level_1'),
      ).long_name;
    } else if (event) {
      // support manual string from enter press
      value = event;
    }
    const isTargetValueInExcludedCities: boolean = this.excludedCities.some((val) => val === value);
    if (!isTargetValueInExcludedCities) {
      this.excludedStates.push(value);
    }

    this.excludedStatesControl.setValue('');
    this.excludedStatesListMethodAutocomplete.elemRef.nativeElement.value = '';
    this.changeTracker.refresh();
  }

  onExcludedCityAdd(event: any): void {
    let value = (event.name || '').trim();
    const geoDeliveryArea: string = this.getField('geoDeliveryArea')?.value;

    // get only city name
    if (event.types && geoDeliveryArea !== 'states') {
      value = event.address_components.find(
        (component) => component.types.includes('locality') || component.types.includes('sublocality'),
      ).long_name;
    }

    // get only state name
    if (event.types && geoDeliveryArea === 'states') {
      value = event.address_components.find((component) =>
        component.types.includes('administrative_area_level_1'),
      )?.long_name;
    }

    const isTargetValueInExcludedCities: boolean = this.excludedCities.some((val) => val === value);
    if (!isTargetValueInExcludedCities) {
      this.excludedCities.push(value);
    }

    this.excludedCitiesControl.setValue('');
    this.excludedCitiesListMethodAutocomplete.elemRef.nativeElement.value = '';
    this.changeTracker.refresh();
  }

  onCityRemove(city: string, index: number): void {
    if (index >= 0) {
      this.selectedCities.splice(index, 1);
      this.selectValueFromPolygonAutocompleteCoors.splice(index, 1);
    }
  }

  onExcludedCityRemove(city: string, index: number): void {
    if (index >= 0) {
      this.excludedCities.splice(index, 1);
    }
    this.changeTracker.refresh();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedCities.push(event.option.viewValue);
    this.citiesListMethodAutocomplete.elemRef.nativeElement.value = '';
    this.getCitiesControl.setValue(null);
  }

  onCountySearch(): void {
    this.isLoadingData = true;
    this.isCheckoutFormInvalid = false;
    this.polygonCmp.onApplyGeo(GEODeliveryArea.COUNTY, ShippingMethod.LOCAL, this.localCountySelected, true);
  }

  onLocalCountySelected(event): void {
    if (!event) {
      this.disableApply = true;
      return;
    }

    if (!event.formatted_address?.toLowerCase()?.includes(GEODeliveryArea.COUNTY)) {
      this.dialog.open(ErrorDialog, {
        data: {
          msg: `Please include county on your search, for example: \n Orange county`,
        },
      });
      this.isCheckoutFormInvalid = true;
      this.disableApply = true;
      return;
    }

    this.disableApply = false;
    this.localCountySelected = {
      name: event.formatted_address.trim(),
      point: [event.geometry.location.lat(), event.geometry.location.lng()],
    };
  }

  onZonesChange(options: Options[]): void {
    const validOptions = options.filter((val) => val.value == true);

    this.isCheckoutFormInvalid = validOptions?.length < 1;

    this.setLocationSettingsValues({
      originZipCode: this.zonesOriginAddress.originZipCode,
      address: this.zonesOriginAddress.address,
      zonesList: options,
    });
  }

  onZonesOriginAddressSelected(event) {
    const originZipCode = event.address_components.find((component) =>
      component.types.includes('postal_code'),
    )?.long_name;
    const address = event.formatted_address;
    if (!originZipCode || !address) {
      this.dialog.open(PolygonSuccessDialog, {
        data: {
          msg: 'No valid zip code or address for entered data, TRY AGAIN',
        },
      });
      return;
    }

    this.setZonesOriginAddress({ originZipCode, address });
  }

  setZonesOriginAddress(zonesOriginAddress: ZonesOriginAddress): void {
    this.zonesOriginAddress = zonesOriginAddress;
    this.selectedAddressForZonesTypeControl.setValue(zonesOriginAddress.address ?? null);
    this.setLocationSettingsValues({
      originZipCode: zonesOriginAddress.originZipCode,
      address: zonesOriginAddress.address,
    });
  }

  async onLocalMethodCityChoose(event): Promise<void> {
    if (event && this.shippingMethodCategory == ShippingMethod.LOCAL) {
      this.localMethodCityChoose = {
        name: event.formatted_address.trim(),
        point: [event.geometry.location.lat(), event.geometry.location.lng()],
      };
      this.changeTracker.refresh();
      await this.polygonCmp.initLocalCityModeBoundary(this.localMethodCityChoose);
    }
  }

  getRunningABTest(variants: ICheckoutVariantABTest[]): ICheckoutVariantABTest | null {
    const runningTest = variants?.find((v) => !!v.createdAt && !v.finishedAt);
    return runningTest ?? null;
  }

  setCheckoutValue(checkout: Shippings): void {
    this.selectedCities = [];
    this.shopSettings.primaryLocation = formatAddress(checkout.shippedFromLocationAddress as any);
    this.checkoutService.setInitPrimaryLocationView(this.shopSettings.primaryLocation);
    if (checkout.shippedFromLocationAddress) {
      this.shopSettings.selectedLocationCountry = checkout.shippedFromLocationAddress.countryCode;
      const locationAlreadyExists = this.shopSettings.locations.find(
        (l) => l?.id == checkout.shippedFromLocationAddress?.id,
      );
      if (!locationAlreadyExists) {
        this.shopSettings.locations.push({
          originLocation: checkout.shippedFromLocationAddress?.address1
            ? formatAddress(checkout.shippedFromLocationAddress as any)
            : checkout.shippedFromLocationAddress.storeName,
          isPrimary: checkout.shippedFromLocationAddress['isPrimaryLocation'],
          id: checkout.shippedFromLocationAddress.id,
          zip: checkout.shippedFromLocationAddress.zip,
          country: checkout.shippedFromLocationAddress.country,
        });
      }
    }

    this.stepOne = checkout?.deliveryType;
    this.stepTwo = checkout?.shippingMethod?.category;
    this.shippingMethodCategory = checkout?.shippingMethod?.category;
    this.deliveryType = checkout?.deliveryType;
    this.loadedCarrier = checkout?.carrier;
    this.shipmentExtras = checkout?.shipmentExtras;
    this.agreementFileURL = checkout?.agreementFileURL;
    this.polygonInputValues = checkout?.polygonInputValues;
    if (this.loadedCarrier) {
      this.checkoutService.setSelectedCarrier(this.loadedCarrier);
    }
    this.formGroup.patchValue({
      allConditions: checkout?.allConditions,
      displayEstDelivery: checkout?.displayEstDelivery,
      displayEstimatedDeliveryBusinessDays: checkout?.displayEstimatedDeliveryBusinessDays,
      shippingMethodId: checkout?.shippingMethodId,
      name: checkout?.name,
      deliveryType: checkout?.deliveryType,
      internalName: checkout?.internalName ?? '',
      deliveryMethodSectionId: checkout?.deliveryMethodSectionId ?? '',
      shippingMethodCategory: checkout?.shippingMethod?.category,
      shippingMethodDetail: checkout?.shippingMethod,
      carrierId: this.loadedCarrier?.id,
      rate: checkout?.rate,
      expectedPickupTime: checkout?.cost,
      minOrderPriceRange: checkout?.minOrderPriceRange ? checkout?.minOrderPriceRange : 0,
      maxOrderPriceRange: checkout?.maxOrderPriceRange ? checkout?.maxOrderPriceRange : null,
      linkedDatePickerExtensionId: checkout?.linkedDatePickerExtensionId ?? null,
      linkedMultiShipDatePickerProfile: checkout?.linkedMultiShipDatePickerProfile ?? null,
      notes: checkout?.notes,
      location: checkout?.location,
      cost: checkout?.cost > 0 ? checkout?.cost : '',
      isDynamicCost: checkout?.isDynamicCost,
      costPer: checkout?.constPer,
      feePerItem: {
        enabled: checkout.feePerItemEnabled,
      },
      international: {
        taxPaymentType:
          checkout.internationalSettings?.taxPaymentType ?? this.shop?.internationalSettings?.incoterm ?? 'DDU',
        countriesAndRegions: checkout.internationalSettings?.countriesAndRegions ?? {
          US: countryCodeToStates['US'].map((state) => state.value),
        },
        deliveryAreaZipCodes: checkout.internationalSettings?.deliveryAreaZipCodes || {},
        ddpConfig: checkout.internationalSettings?.ddpConfig || {},
      },
      deliveryPromiseDeliveryTimeSettings: {
        useMetafieldProcessingTime: this.shippingMethodDetail?.useMetafieldProcessingTime ?? false,
        minProcessingDays: this.getMinProcessingDays(),
        maxProcessingDays: this.getMaxProcessingDays(),
        minTransitDays: this.getMinTransitDays(),
        maxTransitDays: this.getMaxTransitDays(),
        minHours: this.getMinHours(),
        maxHours: this.getMaxHours(),
        metafieldProcessingTime: this.shippingMethodDetail?.metafieldProcessingTime ?? null,
        metafieldProcessingTimeFallback: this.shippingMethodDetail?.metafieldProcessingTimeFallback ?? null,
        combineConsecutiveDays: this.shippingMethodDetail?.combineConsecutiveDays ?? false,
      },
      deliveryDaysAndTimesHolidays: checkout?.deliveryDaysAndTimesHolidays ?? 'none',
      SLABDays:
        formattedServiceLevelTime(this.shippingMethodCategory, checkout?.shipmentExtras?.maximalShippingHours) ??
        checkout?.SLABDays,
      deliveryPromiseType:
        checkout?.shippingMethod?.maxDays ||
        checkout?.shippingMethod?.maxProcessingDays ||
        checkout?.shippingMethod?.useMetafieldProcessingTime
          ? 'days'
          : 'hours',
      agreementFileURL: checkout?.agreementFileURL,
      ordersPerDay: checkout?.ordersPerDay,
      weightUnit: checkout?.weightUnit,
      startDate: undefined,
      endDate: undefined,
      blackoutDaysNote: [''],
      filterSelected: [''],
      conditionSelects: [''],
      typeInput: [''],
      shippedFromLocation: +checkout?.shippedFromLocation,
      deliveryDaysAllWeek: checkout?.deliveryDaysAllWeek,
      additionalPriceRanges: checkout?.additionalPriceRanges,
      hasDiscount: checkout?.hasDiscount ?? false,
      discountType: checkout?.discountType ?? 'fixed',
      discountAmount: checkout?.discountAmount ?? null,
      loyalCustomerPrice: checkout?.loyalCustomerPrice,
      estimatedAverageShippingCost: checkout?.estimatedAverageShippingCost ?? 0,
      loyalCustomerDescription: checkout?.loyalCustomerDescription,
      limitUnfulfilledOrders: checkout?.limitUnfulfilledOrders,
      metadata: checkout?.metadata,
      attachLocation: checkout?.attachLocation,
      calculatePackageDimension: checkout.calculatePackageDimension,
      rateConversion: checkout.rateConversion,
      flatAmount: checkout.flatAmount,
      percentageOfCarrierCost: checkout.percentageOfCarrierCost,
      estimatedTimeConversions: checkout.estimatedTimeConversions ?? 'manual',
      displayMethodAndServiceLevelName: checkout.displayMethodAndServiceLevelName,
      serviceCodeInput: checkout.serviceCodeInput,
      isTestMode: checkout.isTestMode,
      deliveryPromisePdqIqBaseShippingMethod: checkout?.deliveryPromisePdqIqBaseShippingMethod,
      deliveryPromisePdqIqPercentile: checkout?.deliveryPromisePdqIqPercentile,
      maxxAiDeliveryPromiseEnabled: checkout?.maxxAiConfiguration?.maxxAiDeliveryPromiseEnabled ?? false,
      maxxAiDeliveryPromiseMinCap: checkout?.maxxAiConfiguration?.maxxAiDeliveryPromiseMinCap ?? null,
      methodCurrency: checkout.methodCurrency ?? this.shopSettings.shopCurrency,
      deliveryPromiseArrivalSingleDateDisplayText: checkout.deliveryPromiseArrivalSingleDateDisplayText,
      deliveryPromiseArrivalDateRangeDisplayText: checkout.deliveryPromiseArrivalDateRangeDisplayText,
      latestArrivalDateToFilter: checkout.latestArrivalDateToFilter,
    });

    if (checkout.methodCurrency) {
      this.checkoutService.shippingMethodCurrency = checkout.methodCurrency;
    }

    /** Fee per item start */
    const feePerItemControl = this.formGroup.get('feePerItem') as UntypedFormGroup;
    const feeRules = feePerItemControl.get('feeRules') as UntypedFormArray;
    feeRules.clear();
    feePerItemControl.controls.enabled.setValue(!!checkout?.feePerItemEnabled);
    checkout?.feePerItemRules?.forEach((rule) => {
      feeRules.push(
        FeePerItemComponent.createFeeControl(rule.amount, rule.type, rule.step, rule.stepUnit, rule.threshold),
      );
    });

    const groupRules = feePerItemControl.get('groupRules') as UntypedFormArray;
    groupRules.clear();
    checkout?.itemFeeConfiguration?.rules?.forEach((rule) => {
      groupRules.push(ItemFeeRulesComponent.createGroupRuleControl(rule));
    });
    feePerItemControl.controls.byProductGroup.setValue(!!checkout?.itemFeeByProductGroup);
    feePerItemControl.controls.overlapMode.setValue(
      checkout?.itemFeeConfiguration?.overlapMode ?? Checkout.RuleOverlapMode.FIRST,
    );
    feePerItemControl.controls.unmatchedFee.setValue(fromUnmatchedFee(checkout?.itemFeeConfiguration?.unmatchedFee));
    feePerItemControl.controls.configurationId.setValue(checkout?.itemFeeConfigurationId ?? null);
    /** Fee per item end */

    const deliveryPromiseRestrictionControl = this.formGroup.get('deliveryPromiseRestriction') as UntypedFormGroup;
    deliveryPromiseRestrictionControl.controls.enabled.setValue(checkout.deliveryPromiseRestriction?.enabled ?? false);
    deliveryPromiseRestrictionControl.controls.fallbackText.setValue(
      checkout.deliveryPromiseRestriction?.fallbackText ?? '',
    );
    const deliveryPromiseRestrictionRules = deliveryPromiseRestrictionControl.get('rules') as UntypedFormArray;
    const rulesFormArray = this.dynamicRulesService.initRulesFormArray(
      checkout.deliveryPromiseRestriction?.rules || [],
      DeliveryPromiseRestrictionRules,
    );
    rulesFormArray.controls.forEach((control) => {
      deliveryPromiseRestrictionRules.push(control);
    });

    checkout?.additionalPriceRanges?.map((additionalPriceRange: AdditionalPriceRanges) => {
      this.additionalPriceRanges.push(buildPriceTierControl(additionalPriceRange));
    });

    checkout.customBlackoutDates?.map((blackoutDate: any) => {
      const addLine = this.formBuilder.group({
        startDate: blackoutDate?.startDate,
        endDate: blackoutDate?.endDate,
        note: blackoutDate?.note,
      });
      this.blackoutDaysField.push(addLine);
    });

    const groupedData = checkout.conditions
      .filter((condition: any) => condition?.name != 'locations')
      .reduce((groups, item: any) => {
        (groups[item.subsetGroupId] = groups[item.subsetGroupId] || []).push(item);
        return groups;
      }, {});

    for (const groupId in groupedData) {
      const formArray = this.formBuilder.array(
        groupedData[groupId].map((condition) => buildConditionControl(condition)),
      );
      this.conditionsField.push(formArray);
    }

    checkout.conditions
      ?.filter((condition: any) => condition?.name === 'locations')
      .map((condition: any) => {
        if (
          !checkout?.deliveryAreaSelectMethod ||
          checkout?.deliveryAreaSelectMethod == GEODeliveryAreaMethod.ALL_CITIES
        ) {
          this.setField('geoDeliveryArea', true);
        } else {
          this.loadedPolygonStage = checkout?.deliveryAreaSelectMethod;
          if (this.loadedPolygonStage.includes(GEODeliveryArea.STATES)) {
            this.setField('geoDeliveryArea', GEODeliveryArea.STATES);
          } else if (this.loadedPolygonStage.includes(GEODeliveryArea.COUNTY)) {
            this.setField('geoDeliveryArea', GEODeliveryArea.COUNTY);
            checkout.deliveryAreaSelectMethod = GEODeliveryAreaMethod.COUNTY;
          } else if (this.loadedPolygonStage.includes(GEODeliveryArea.ZONES)) {
            this.setField('geoDeliveryArea', GEODeliveryArea.ZONES);
          } else if (this.loadedPolygonStage.includes(GEODeliveryArea.ZIP_CODES)) {
            this.setField('geoDeliveryArea', GEODeliveryArea.ZIP_CODES);
          } else if (this.loadedPolygonStage.includes(GEODeliveryArea.CUSTOM)) {
            this.setField('geoDeliveryArea', GEODeliveryArea.CUSTOM);
          } else {
            this.setField('geoDeliveryArea', false);
          }
          this.setField('geoDeliveryAreaMethod', checkout?.deliveryAreaSelectMethod);
          this.deliveryAreaMethodRadioGroup = checkout?.deliveryAreaSelectMethod;
          switch (checkout?.deliveryAreaSelectMethod) {
            case 'cities_from_address_radius':
            case 'states_from_address_radius':
            case 'custom_from_address_radius':
            case 'streets_from_address_radius': {
              this.polygonAddress = checkout?.polygonInputValues[0]?.address;
              this.maxPolygonRadius = checkout?.polygonInputValues[0]?.maxRadius ?? null;
              this.polygonRadius = checkout?.polygonInputValues[0]?.radius;
              if (!this.maxPolygonRadius && this.polygonRadius) {
                this.maxPolygonRadius = this.polygonRadius;
                this.polygonRadius = 0;
              }
              this.polygonRadiusUnits = checkout?.polygonInputValues[0]?.radiusUnits;
              this.setField('polygonRadiusUnits', this.polygonRadiusUnits);
              this.polygonCities = []; // for now dont fetch any cities or streets
              this.polygonLatLngs = checkout?.polygonInputValues[0]?.circleRingBoundary
                ? checkout?.polygonInputValues[0]?.circleRingBoundary
                : checkout?.polygonInputValues[0]?.latlng;
              if (checkout?.polygonInputValues[0]?.latlng) {
                this.selectValueFromPolygonAutocompleteCoors.lat = checkout?.polygonInputValues[0].latlng[0];
                this.selectValueFromPolygonAutocompleteCoors.lng = checkout?.polygonInputValues[0].latlng[1];
              }
              break;
            }

            case 'cities_from_list':
            case 'states_from_list':
            case 'streets_from_list': {
              checkout?.polygonInputValues[0]?.selectedCities?.map((value: string) => {
                this.selectedCities.push(value);
              });
              checkout.polygonInputValues[0].selectedCitiesCoors?.map((val) => {
                this.selectValueFromPolygonAutocompleteCoors.push({
                  lat: val[0],
                  lng: val[1],
                });
              });
              this.polygonCities = []; // for now dont fetch any cities or streets
              this.polygonLatLngs = checkout?.polygonInputValues[0]?.selectedCitiesCoors;
              break;
            }

            case 'pen_tool':
            case 'custom_pen_tool':
            case 'states_pen_tool': {
              this.selectedOnDrawerMode = checkout?.polygonInputValues
                ? checkout?.polygonInputValues[0]?.coordinates
                : '';
              this.setField('geoDeliveryAreaMethod', false);
              this.polygonCities = []; // for now dont fetch any cities or streets
              break;
            }
            case 'county': {
              this.polygonLatLngs = checkout?.polygonInputValues[0]?.countyCoordinates;
              this.localCountySelected.name = checkout?.polygonInputValues[0]?.address;
              break;
            }
            case 'zones': {
              this.zonesOriginAddress = {
                address: checkout?.polygonInputValues[0]?.address,
                originZipCode: checkout?.polygonInputValues[0]?.originZipCode,
              };
              this.selectedAddressForZonesTypeControl.setValue(this.zonesOriginAddress.address ?? null);
              this.zoneOptions = checkout?.polygonInputValues[0]?.zonesList;
              const loadedZones: string[] = [];
              if (this.zoneOptions) {
                this.zoneOptions.forEach((val) => {
                  if (val.value == true) {
                    loadedZones.push(val.label);
                  }
                });
              }
              this.zonesPlaceholder = loadedZones.join(', ');
              break;
            }
            case 'zip_codes': {
              this.formGroup.addControl(
                'GEODeliveryAreaZipCodes',
                new UntypedFormControl(
                  '',
                  Validators.pattern(
                    /^[a-zA-Z0-9*]+(?:[-\s][a-zA-Z0-9*]+)*(?:,\s*[a-zA-Z0-9*]+(?:[-\s][a-zA-Z0-9*]+)*)*$/,
                  ),
                ),
              );
              this.formGroup.addControl('GEODeliveryAreaZipCodesOperator', new UntypedFormControl('includes'));
              this.setField('GEODeliveryAreaZipCodes', checkout?.polygonInputValues[0]?.zipCodes);
              this.setField('GEODeliveryAreaZipCodesOperator', checkout.polygonInputValues[0]?.zipCodesOperator);
            }
          }
        }

        checkout?.polygonInputValues[0]?.excludedCities &&
          checkout?.polygonInputValues[0]?.excludedCities?.map((value: string) => {
            this.excludedCities.push(value);
          });
        checkout?.polygonInputValues[0]?.listedStates &&
          checkout?.polygonInputValues[0]?.listedStates?.map((value: string) => {
            this.listedStates.push(value);
          });
        const statesToControl = this.listedStatesToListedStatesControl(checkout?.polygonInputValues[0]?.listedStates);
        if (statesToControl) {
          this.listedStatesControl.setValue(statesToControl);
          this.listedStates = [];
        }
        checkout?.polygonInputValues[0]?.listedCities &&
          checkout?.polygonInputValues[0]?.listedCities?.map((value: string) => {
            this.listedCities.push(value);
          });
        checkout?.polygonInputValues[0]?.excludedStates &&
          checkout?.polygonInputValues[0]?.excludedStates?.map((value: string) => {
            this.excludedStates.push(value);
          });
        if (checkout?.polygonInputValues[0]?.listedStatesControl) {
          this.listedStatesControl.setValue(checkout.polygonInputValues[0].listedStatesControl);
        }
        this.localMethodCityChoose = checkout?.polygonInputValues[0]?.localMethodCityChoose;
        this.setLocationSettingsValues({ ...checkout?.polygonInputValues[0] });
      });

    checkout.shippingMethod?.metadata?.map((deliveryPromise: any) => {
      if (deliveryPromise.value) {
        if (Array.isArray(deliveryPromise.value)) {
          deliveryPromise.value?.map((value) => {
            const addLine = this.formBuilder.group({
              type: deliveryPromise.type,
              value: value,
            });
            this.deliveryPromiseDontCalculateOnFields.push(addLine);
          });
        } else {
          Object.keys(deliveryPromise.value)?.map((value) => {
            const addLine = this.formBuilder.group({
              type: deliveryPromise.type,
              value: value,
            });
            this.deliveryPromiseDontCalculateOnFields.push(addLine);
          });
        }
      }
    });

    this.setDeliveryDaysAndTimes(checkout.deliveryDaysAndTimes ?? []);
    this.formGroup.updateValueAndValidity();
    this.initOnEditModeOpenAccordions();
  }

  // extras arrive after the snapshot, so they'd read as changes
  onShipmentExtrasLoaded(): void {
    this.changeTracker.absorb(['shipmentExtras', 'shipmentExtrasId']);
  }

  setDeliveryDaysAndTimes(days: ScheduleDay[]): void {
    days.forEach((dayNtime) => {
      const day = this.convertFirstLetterToUpperCase(dayNtime.day);
      this.setField(day, dayNtime.enable);
      this.setField('from' + day, getTwentyFourHourTime(dayNtime?.fromTime));
      this.setField('to' + day, getTwentyFourHourTime(dayNtime?.toTime));
    });
  }

  getMinProcessingDays(): number {
    const { estimatedTimeConversions } = this.formGroup.value;

    if (this.shippingMethodCategory === ShippingMethod.LOCAL) {
      return null;
    }

    if (!estimatedTimeConversions || estimatedTimeConversions === ICheckoutEstimatedTimeConversion.MANUAL) {
      //fixed
      return this.shippingMethodDetail?.minProcessingDays;
    } else if (estimatedTimeConversions === ICheckoutEstimatedTimeConversion.LINKED_CALENDAR) {
      return null;
    } else if (
      estimatedTimeConversions === ICheckoutEstimatedTimeConversion.PDQIQ ||
      estimatedTimeConversions === ICheckoutEstimatedTimeConversion.LIVE
    ) {
      if (
        this.shippingMethodDetail?.minProcessingDays !== null &&
        this.shippingMethodDetail?.minProcessingDays !== undefined
      ) {
        if (
          this.shippingMethodDetail?.minProcessingDays === 0 &&
          this.shippingMethodDetail?.maxProcessingDays === 0 &&
          this.shippingMethodDetail?.minDays !== null &&
          this.shippingMethodDetail?.minDays !== undefined &&
          this.shippingMethodDetail?.maxDays !== null &&
          this.shippingMethodDetail?.maxDays !== undefined &&
          this.shippingMethodDetail?.minDays > 0 &&
          this.shippingMethodDetail?.maxDays > 0
        ) {
          return this.shippingMethodDetail?.minDays;
        }
        return this.shippingMethodDetail?.minProcessingDays;
      } else if (this.shippingMethodDetail?.minDays !== null && this.shippingMethodDetail?.minDays !== undefined) {
        return this.shippingMethodDetail?.minDays;
      }
    }

    return null;
  }

  getMaxProcessingDays(): number {
    const { estimatedTimeConversions } = this.formGroup.value;

    if (this.shippingMethodCategory === ShippingMethod.LOCAL) {
      return null;
    }

    if (!estimatedTimeConversions || estimatedTimeConversions === ICheckoutEstimatedTimeConversion.MANUAL) {
      //fixed
      return this.shippingMethodDetail?.maxProcessingDays;
    } else if (estimatedTimeConversions === ICheckoutEstimatedTimeConversion.LINKED_CALENDAR) {
      return null;
    } else if (
      estimatedTimeConversions === ICheckoutEstimatedTimeConversion.PDQIQ ||
      estimatedTimeConversions === ICheckoutEstimatedTimeConversion.LIVE
    ) {
      if (
        this.shippingMethodDetail?.maxProcessingDays !== null &&
        this.shippingMethodDetail?.maxProcessingDays !== undefined
      ) {
        if (
          this.shippingMethodDetail?.minProcessingDays === 0 &&
          this.shippingMethodDetail?.maxProcessingDays === 0 &&
          this.shippingMethodDetail?.minDays !== null &&
          this.shippingMethodDetail?.minDays !== undefined &&
          this.shippingMethodDetail?.maxDays !== null &&
          this.shippingMethodDetail?.maxDays !== undefined &&
          this.shippingMethodDetail?.minDays > 0 &&
          this.shippingMethodDetail?.maxDays > 0
        ) {
          return this.shippingMethodDetail?.maxDays;
        }
        return this.shippingMethodDetail?.maxProcessingDays;
      } else if (this.shippingMethodDetail?.maxDays !== null && this.shippingMethodDetail?.maxDays !== undefined) {
        return this.shippingMethodDetail?.maxDays;
      }
    }

    return null;
  }

  getMinTransitDays(): number {
    const { estimatedTimeConversions } = this.formGroup.value;

    if (this.shippingMethodCategory === ShippingMethod.LOCAL) {
      return null;
    }

    if (!estimatedTimeConversions || estimatedTimeConversions === ICheckoutEstimatedTimeConversion.MANUAL) {
      //fixed
      return this.shippingMethodDetail?.minDays;
    }
    return null;
  }

  getMaxTransitDays(): number {
    const { estimatedTimeConversions } = this.formGroup.value;

    if (this.shippingMethodCategory === ShippingMethod.LOCAL) {
      return null;
    }

    if (!estimatedTimeConversions || estimatedTimeConversions === ICheckoutEstimatedTimeConversion.MANUAL) {
      //fixed
      return this.shippingMethodDetail?.maxDays;
    }
    return null;
  }

  getMinHours(): number {
    if (this.shippingMethodCategory === ShippingMethod.LOCAL) {
      return this.shippingMethodDetail?.minHours;
    }
    return null;
  }

  getMaxHours(): number {
    if (this.shippingMethodCategory === ShippingMethod.LOCAL) {
      return this.shippingMethodDetail?.maxHours;
    }
    return null;
  }

  onChooseDeliveryType(event: string): void {
    if (event) {
      if (!this.stepTwo) {
        this.stepOne = event;
        this.deliveryType = event;
        this.stepTwo = null;
      } else {
        const dialogRef = this.dialog.open(PolygonSuccessDialog, {
          data: {
            msg: `You have unsaved changes \n Leave anyway?`,
            step: 'discardDeliveryMethod',
          },
        });
        const detectAction = dialogRef.componentInstance?.onDeliveryMethod.subscribe((value) => {
          if (value === 'close') {
            this.stepOne = null;
            this.deliveryType = null;
            this.shippingMethodCategory = null;
            this.stepTwo = null;
            this.formGroup.clearValidators();
            this.formGroup.reset();
            this.checkoutService.setFormReset(true);
          } else {
            return;
          }
        });
        dialogRef.afterClosed().subscribe(() => {
          detectAction?.unsubscribe();
        });
      }
    }
  }

  onButtonChange({ value }): void {
    const changeShippingMethodCategory = () => {
      const testMode = this.formGroup.value['isTestMode'];
      const preservedNotes = this.formGroup.get('notes')?.value;
      this.formGroup.clearValidators();
      this.formGroup.reset();
      this.stepTwo = value;
      this.shippingMethodCategory = value;
      this.initForm();
      this.loadedPolygonStage = '';
      this.setLocationSettingsValues();
      this.accordionActiveSection = [];
      this.editMode = false;
      this.checkoutService.setFormReset(true);
      this.loadedCarrier = null;
      this.initShopSettings();
      this.setField('isTestMode', testMode);
      this.setField('shippingMethodCategory', value);
      if (preservedNotes) {
        this.setField('notes', preservedNotes);
      }
      this.checkoutService.setSelectedCarrier(null);
    };
    const keepCurrentShippingMethodCategory = () => {
      // should preserve current shippingMethodCategory select
      console.log('keepCurrentShippingMethodCategory: ', this.shippingMethodCategory);
      this.setField('shippingMethodCategory', this.shippingMethodCategory);
    };

    if (
      this.editMode ||
      (this.formGroup.dirty && Object.entries(this.formGroup.controls).some((c) => c[0] !== 'isTestMode' && c[1].dirty))
    ) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: `Unsaved Changes`,
          description: `If you leave now, your changes will be lost.\nDo you want to discard them?`,
          confirmText: 'Exit without saving',
          cancelText: 'Keep editing',
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((value) => {
        value ? changeShippingMethodCategory() : keepCurrentShippingMethodCategory();
      });
    } else {
      changeShippingMethodCategory();
    }
  }

  onOpenExpansion(event): any {
    if (event) {
      this.showExpansionGuide = event;
      if (this.editMode && event == 'geographySettings') {
        this.polygonCmp?.onApplyGeo(this.loadedPolygonStage);
      }
      if (event == 'geographySettings') {
        this.scrollToTarget('conditionsId');
      }
    }
    return true;
  }

  onCloseExpansion(): void {
    this.showExpansionGuide = null;
  }

  isExpandedNeeded(sectionTitle: string): boolean {
    return this.accordionActiveSection.some((value) => value == sectionTitle);
  }

  setField(str: string, value: string | boolean | number | any): any {
    if (!this.formGroup.controls) {
      return;
    }

    return this.formGroup['controls'][str]?.setValue(value);
  }

  getField(str: string): any {
    return this.formGroup.get(str);
  }

  async onSubmit() {
    if (this.isCheckoutFormInvalid) {
      this.dialog.open(ErrorDialog, {
        data: {
          msg: `Please, apply your location settings`,
        },
      });
      return;
    }

    this.showFormErrors = false;
    this.checkInvalidControlsAndOpenSections();
    this.removeEmptyConditionRows();

    if (this.showFormErrors || this.formGroup.invalid) {
      //do nothing
    } else {
      if (this.runningABTest) {
        // if we have running test, display relevant pop up to ensure the action
        const runningTestSaveDialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: {
            title: `You are editing a running A/B test`,
            description: `Your changes will apply to both the A and B variations of an active test. Continue and save?`,
          },
          disableClose: true,
        });
        runningTestSaveDialogRef.afterClosed().subscribe(async (value) => {
          value ? await this.submitData() : null;
        });
      } else {
        if (this.geoDeliveryAreaMethod?.value == GEODeliveryAreaMethod?.LISTED_STATES) {
          if (this.listedStatesControl.value === null || Object.keys(this.listedStatesControl.value).length === 0) {
            this.listedStatesControl.setErrors({ required: true });
            return;
          }
        }
        await this.submitData();
      }
    }
  }

  submitData(): void {
    const payload = this.buildPayload();

    if (!this.updatesExistingMethod) {
      this.isLoading = true;
      this.deactivateGuard.onSubmit(true);
      this.submitForm.emit(this.forSave(payload));
      this.formGroup.reset();
      return;
    }

    // stale check is async: a double click would open two reviews
    if (this.reviewInProgress) return;
    this.reviewInProgress = true;

    this.staleSave
      .checkForNewerSave({
        entityName: 'This method',
        opened: this.openedEntity,
        savedPayload: this.changeTracker.baseline,
        loadLatest: () => this.formService.loadCheckoutById(this.openedEntity.id),
        auditLog: { where: 'Checkout Group', location: `DeliveryMethod:${this.openedEntity.id}` },
        entityPaths: SHIPPING_ENTITY_PATHS,
        isSame: (path, a, b) => {
          const config = this.buildReviewConfig(this.changeTracker.baseline);
          return !diffChanges({ [path]: a }, { [path]: b }, config).length;
        },
      })
      .pipe(
        switchMap((newerSave) => {
          const baseline = newerSave?.baseline ?? this.changeTracker.baseline;
          return this.changeReview.review(baseline, () => this.buildPayload(), this.buildReviewConfig(baseline), {
            stale: newerSave?.banner,
            onViewAuditLogs: () => this.staleSave.openAuditLogs(),
            revert: (entry) => this.revert.resolve(entry, baseline),
          });
        }),
        // reverts can touch lists that live outside the form
        tap(() => {
          this.reviewInProgress = false;
          this.changeTracker.refresh();
        }),
        finalize(() => (this.reviewInProgress = false)),
        filter((result) => result === 'confirmed'),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        // a revert can leave the form invalid
        if (this.isCheckoutFormInvalid || this.formGroup.invalid) {
          this.onSubmit();
          return;
        }
        const confirmedPayload = this.buildPayload();
        this.changeTracker.submit(confirmedPayload);
        this.isSaving = true;
        this.submitForm.emit(this.forSave(confirmedPayload));
      });
  }

  prepareConditionsToSave() {
    const conditions = [];
    const conditionsField = this.conditionsField.controls.filter(isFilledConditionGroup);
    const updateSubsetGroupId = conditionsField.length > 1;
    conditionsField.forEach((group: UntypedFormArray, index: number) => {
      // onSubmit drops empty rows; skip them so the baseline matches
      group.controls
        .filter((control) => !isEmptyConditionRow(control))
        .forEach((control: UntypedFormGroup) => {
          const condition = {
            name: control.value.name,
            displayName: control.value.displayName,
            condition: control.value.condition,
            values: control.value.value1 + (control.value.value2 ? '||' + control.value.value2 : ''),
            weightUnit: control.value.weightUnit,
            subsetGroupId: updateSubsetGroupId ? index + 1 : null,
            optionalValue: control.value.optionalValue,
          };
          conditions.push(condition);
        });
    });

    this.conditionsField.controls
      .filter((control) => control instanceof UntypedFormGroup)
      .forEach((control: UntypedFormGroup) => {
        conditions.push(control.value);
      });
    return conditions;
  }

  // form errors don't disable Save: onSubmit highlights them
  isSaveDisabled(): boolean {
    return (
      (this.isInternationalMethod() && !this.shop?.internationalSettings?.isActive) ||
      !this.stepTwo ||
      !this.stepOne ||
      (this.updatesExistingMethod && !this.changeTracker.hasUnsavedChanges)
    );
  }

  onDiscard(): void {
    this.router.navigate([`${CHECKOUT_URL}`]);
  }

  showDialogWindow(message = '', confirmCallback = () => {}, cancelCallback = () => {}): void {
    const dialogRef = this.dialog.open(PolygonSuccessDialog, {
      data: {
        msg: message,
        step: 'discardDeliveryMethod',
      },
    });
    const detectAction = dialogRef.componentInstance?.onDeliveryMethod.subscribe((value) => {
      if (value == 'close') {
        confirmCallback();
      } else {
        cancelCallback();
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      detectAction?.unsubscribe();
    });
  }

  convertFirstLetterToUpperCase(str: string): string {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  }

  compareWith(obj1: any, obj2: any): boolean {
    return obj1?.id === (obj2?.id || obj2) ? obj1.originLocation : isNaN(obj1?.id) ? obj1.originLocation : false;
  }

  onShippedFromLocationChange(event): void {
    const changePrimaryShopLocation = true;
    this.shopSettings.primaryLocation = event.value.originLocation;
    this.listedStatesControl.reset();
    if (event.value.countryCode) {
      this.shopSettings.selectedLocationCountry = event.value.countryCode;
    }
    const previousShippedFromLocationId = this.getField('shippedFromLocation').value;
    this.setField('shippedFromLocation', event.value.id);
    const deliveryArea = this.getField('geoDeliveryArea').value;
    if (
      deliveryArea === GEODeliveryArea.ZONES &&
      isZonesOriginAddressAutoFilledFromShippedFromLocation(
        this.zonesOriginAddress,
        this.shopSettings.locations,
        previousShippedFromLocationId,
      )
    ) {
      this.setZonesOriginAddress(
        buildZonesOriginAddressFromShippedFromLocation(this.shopSettings.locations, event.value.id),
      );
    }
    if (deliveryArea == false || deliveryArea == 'custom') {
      if (this.shippingMethodCategory == 'local') {
        this.localMethodCityChoose = {
          name: this.shopSettings.primaryLocation,
        };
      }
      this.selectValueFromPolygonAutocompleteCoors.lat = this.shopSettings.currentLocationCoords?.lat;
      this.selectValueFromPolygonAutocompleteCoors.lng = this.shopSettings.currentLocationCoords?.lng;
      this.polygonAddress = this.shopSettings.primaryLocation;
      this.polygonCmp.initDefaultLocationZoom(this.shopSettings.primaryLocation, changePrimaryShopLocation);
    }
  }

  checkShippingMethod(type: string): string {
    const deliveryPromiseType = {
      [ShippingMethod.DOMESTIC]: 'Days',
      [ShippingMethod.LOCAL]: 'Hours',
      [ShippingMethod.DOMESTIC_LIVE_RATE]: 'Days',
      [ShippingMethod.INTERNATIONAL_FIXED]: 'Days',
      [ShippingMethod.INTERNATIONAL_LIVE_RATE]: 'Days',
      [ShippingMethod.FIXED_LIVE_RATE]: 'Days',
      [ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE]: 'Days',
      [ShippingMethod.STORE_PICK_UP]: 'Days',
    };

    return deliveryPromiseType[type];
  }

  scrollToTarget(id: string) {
    let top = document.getElementById(id);
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
    const scrolledY = window.scrollY;
    if (scrolledY) {
      window.scroll(0, scrolledY - 65);
    }
  }

  getCitiesStatesStreetsText(): string {
    const geoDeliveryArea: string = this.getField('geoDeliveryArea')?.value;

    if (geoDeliveryArea === 'states' || geoDeliveryArea === 'custom') {
      return geoDeliveryArea;
    }
    return this.shippingMethodCategory == 'local' ? 'streets' : 'cities';
  }

  onDeliveryAreaChange(event): void {
    this.isCheckoutFormInvalid = false;

    const value = event;

    this.currentMethodStage = null;
    if (this.shippingMethodCategory == ShippingMethod.LOCAL) {
      if (value == false) {
        // value false point as streets radio
        this.polygonCmp?.initDefaultLocationZoom(this.shopSettings.primaryLocation, true);
      } else if (value == GEODeliveryArea.COUNTY) {
        this.isCheckoutFormInvalid = true;
        // value county point as county radio
        this.polygonCmp?.clearMap(true);
        this.currentMethodStage = GEODeliveryArea.COUNTY;
      }
    }

    if (value === GEODeliveryArea.CUSTOM) {
      this.currentMethodStage = GEODeliveryArea.CUSTOM;
    }

    if (value == GEODeliveryArea.ZONES) {
      this.isCheckoutFormInvalid = true;
      this.setZonesOriginAddress(
        buildZonesOriginAddressFromShippedFromLocation(
          this.shopSettings.locations,
          this.getField('shippedFromLocation').value,
        ),
      );
    }

    if (value === GEODeliveryArea.ZIP_CODES) {
      this.isCheckoutFormInvalid = true;
      const fgZipCodesRef = this.formGroup.get('GEODeliveryAreaZipCodes');
      const fgZipCodesOperator = this.formGroup.get('GEODeliveryAreaZipCodesOperator');

      // back to zip code option, reset
      if (fgZipCodesRef) {
        this.invalidMessage = undefined;
        fgZipCodesRef.reset();
      }

      if (!fgZipCodesRef) {
        this.formGroup.addControl(
          'GEODeliveryAreaZipCodes',
          new UntypedFormControl(
            '',
            Validators.pattern(/^[a-zA-Z0-9*]+(?:[-\s][a-zA-Z0-9*]+)*(?:,\s*[a-zA-Z0-9*]+(?:[-\s][a-zA-Z0-9*]+)*)*$/),
          ),
        );
      }
      if (!fgZipCodesOperator) {
        this.formGroup.addControl('GEODeliveryAreaZipCodesOperator', new UntypedFormControl('includes'));
      }
    }

    // false align to cities mode
    if (value == false && this.shippingMethodCategory != ShippingMethod.LOCAL) {
      this.tooltipPositionCalc = 'calc(730px - 40px)';
    } else if (value === 'custom') {
      this.tooltipPositionCalc = 'calc(730px - 80px)';
    } else {
      this.tooltipPositionCalc = '730px';
    }

    // reset on delivery area on switch
    this.showPenToolToolTip = false;
    this.polygonCities = [];
    this.selectedCities = [];
    this.excludedCities = [];
    this.excludedStates = [];
    this.selectValueFromPolygonAutocompleteCoors = [];
    this.listedStates = [];
    this.listedCities = [];
    this.listedStatesControl.setValue({});
    this.resetZonesSelection();

    if (value == true) {
      // in case value is true we on everywhere mode no apply check needed
      this.isCheckoutFormInvalid = false;
      this.setLocationSettingsValues();
    }

    this.setLocationSettingsValues({}, true);
    this.deliveryAreaMethodRadioGroup = null;
  }

  onZipCodesOperatorChange(value: string): void {
    this.setField('GEODeliveryAreaZipCodesOperator', value);
    this.onZipCodeTextareaFocusOut();
  }

  onZipCodeTextareaFocusOut(): void {
    this.invalidMessage = undefined;
    this.isCheckoutFormInvalid = false;
    const zcControl = this.formGroup.get('GEODeliveryAreaZipCodes');
    const zcOperatorControl = this.formGroup.get('GEODeliveryAreaZipCodesOperator');
    if (zcControl.invalid) {
      this.isCheckoutFormInvalid = true;
      this.invalidMessage =
        'Please, pay attention valid format for example: 12111,12300-12350,A1A 1A1,K0 31A, L1H*...(allowed only zip code, asterisk, comma and dash)';
    } else if (zcControl.value === '') {
      this.isCheckoutFormInvalid = true;
      this.invalidMessage = 'Please, pay attention you chose zip codes method, but input is empty';
    }

    if (zcControl.valid) {
      const zcValues = {
        type: GEODeliveryArea.ZIP_CODES,
        zipCodes: zcControl.value,
        zipCodesOperator: zcOperatorControl?.value ?? 'includes',
      };

      this.setLocationSettingsValues(zcValues);
    }
  }

  resetZonesSelection(): void {
    this.zoneOptions = this.generateZipCodesOptions();
    this.zonesPlaceholder = DEFAULT_ZONES_PLACEHOLDER;
  }

  generateZipCodesOptions(): Options[] {
    const maxZoneNumber = 8;
    const zipCodesOptions: Options[] = [];

    for (let i = 1; i <= maxZoneNumber; i++) {
      zipCodesOptions.push({ label: `Zone ${i}`, value: false });
    }

    return zipCodesOptions;
  }

  get getConditionalDefaultValuesProps() {
    return {
      category: this.shippingMethodCategory,
      supportedLocale: this.shopService.shopLocale?.includes('he') ? 'he' : 'en',
    };
  }

  private setInitFields(formFields: fieldsConfig[]): any {
    const basicFields = {};

    formFields.map((field: fieldsConfig) => {
      if (field.type == 'array') {
        basicFields[field.fieldName] = this.formBuilder.array([]);

        // set non input values
      } else if (field.type === 'fieldset') {
        basicFields[field.fieldName] = this.formBuilder.group(this.setInitFields(field.fields));
      } else if (field.fieldName === 'shippedFromLocation') {
        basicFields[field.fieldName] = this.shopSettings.locations[0]?.id;
      } else if (field.fieldName === 'location') {
        basicFields[field.fieldName] = this.shopSettings?.shopCountryName;
      } else if (field.fieldName === 'isCustom') {
        basicFields[field.fieldName] = true;
      } else if (field.fieldName === 'deliveryType') {
        basicFields[field.fieldName] = this.deliveryType;
      } else if (field.fieldName === 'taxPaymentType') {
        basicFields[field.fieldName] = this.shop?.internationalSettings?.incoterm ?? 'DDU';
      } else {
        basicFields[field.fieldName] = field.conditionalDefaultValue
          ? field.conditionalDefaultValue(this.getConditionalDefaultValuesProps)
          : [field.defaultValue];
      }

      if (field.validators) {
        if (field.fieldName == 'deliveryType') {
          basicFields[field.fieldName] = [basicFields[field.fieldName], deliveryMethodTypeValidatorFactory(this.shop)];
        } else {
          basicFields[field.fieldName] = [basicFields[field.fieldName], field.validators];
        }
      }
    });
    return basicFields;
  }

  private initForm(): void {
    this.formGroup = this.formBuilder.group(this.setInitFields(this.configFormFields), {
      validators: [
        customDeliveryPromiseValidator(),
        customSLAValidator(),
        customDisplayDeliveryPromisePDQIQValidator(),
      ],
    });
    this.initDynamicValidators(this.shippingMethodCategory);
    this.shipmentExtrasFormGroup = this.formBuilder.group({});
    this.trackUnsavedChanges();
  }

  // initForm rebuilds the form on type change, so resubscribe
  private trackUnsavedChanges(): void {
    this.unsavedChangesSubscription?.unsubscribe();
    this.unsavedChangesSubscription = merge(this.formGroup.valueChanges, this.shipmentExtrasFormGroup.valueChanges)
      .pipe(auditTime(150), takeUntil(this.destroy$))
      .subscribe(() => this.changeTracker.refresh());
  }

  // emptied groups would render as blank Or boxes
  private removeEmptyConditionRows(): void {
    const groups = this.conditionsField.controls;
    for (let groupIndex = groups.length - 1; groupIndex >= 0; groupIndex--) {
      const group = groups[groupIndex];
      if (!(group instanceof UntypedFormArray)) continue;
      for (let rowIndex = group.length - 1; rowIndex >= 0; rowIndex--) {
        const row = group.at(rowIndex);
        Object.values((row as UntypedFormGroup).controls ?? {}).forEach((field) => field.updateValueAndValidity());
        row.updateValueAndValidity();
        if (row.invalid && isEmptyConditionRow(row)) {
          this.shippingRulesEditor
            ? this.shippingRulesEditor.deleteCondition(groupIndex, rowIndex)
            : group.removeAt(rowIndex);
        }
      }
      if (!this.shippingRulesEditor && !group.length) this.conditionsField.removeAt(groupIndex);
      group.updateValueAndValidity();
    }
    this.conditionsField.updateValueAndValidity();
  }

  private buildReviewConfig(baseline: Shippings): ChangeReviewConfig {
    const config = buildShippingMethodReviewConfig(
      `${stripHtmlTags(baseline?.name ?? '')} (#${this.loadValues?.id})`,
      { before: baseline?.methodCurrency, after: () => this.getField('methodCurrency')?.value },
      this.deliveryMethodSectionNames,
      convertCondition,
      (locationId) =>
        this.shopSettings?.locations?.find((location) => String(location.id) === String(locationId))?.originLocation,
      (configurationId) => this.itemFeeSetupState.setupNames[Number(configurationId)],
    );
    return { ...config, ignore: [...(config.ignore ?? []), ...inertFeeFeatures(baseline, this.formGroup?.value)] };
  }

  initDynamicValidators(category: ShippingMethod) {
    const requiredFields = RequiredFormControlsMap[category];
    requiredFields?.forEach((field) => {
      const control = this.formGroup?.get(field.name);
      const controlExistsValidators = control.validator;
      const validators = Validators.compose([controlExistsValidators, Validators.required]);
      if (field.supportedPlatforms) {
        if (field.supportedPlatforms.includes(this.shop.platform)) {
          control.setValidators(validators);
        }
      } else {
        control.setValidators(validators);
      }
    });
  }

  isInternationalMethod() {
    return internationalMethods.includes(this.shippingMethodCategory);
  }

  private checkInvalidControlsAndOpenSections(): void {
    this.showFormErrors = false;
    // An invalid fee rule names itself on the offending row, the way a missing required field turns
    // red. A dialog on top of that says less and hides which row is wrong.
    const feePerItemInvalid = !this.formGroup.controls.feePerItem.valid;
    if (feePerItemInvalid) {
      this.markFeePerItemTouched();
    }
    if (this.hasMissingRequiredField() || feePerItemInvalid) {
      this.showFormErrors = true;
      this.scrollToTarget('top');
    }

    const errorMessage = this.findConfigurationError();
    if (errorMessage) {
      this.showFormErrors = true;
      this.dialog.open(ErrorDialog, {
        data: {
          msg: errorMessage,
        },
      });
    }
  }

  private hasMissingRequiredField(): boolean {
    const requiredFormControls = this.requiredFormControlsMap[this.shippingMethodCategory]?.filter(
      (field) => !field.supportedPlatforms || field.supportedPlatforms.includes(this.shopPlatform),
    );
    return (requiredFormControls ?? []).some((control) => {
      const field = this.formGroup.get(control.name);
      return !field?.valid || field.value == null;
    });
  }

  // so every offending row shows its own message
  private markFeePerItemTouched(): void {
    const feePerItem = this.formGroup.controls.feePerItem as UntypedFormGroup;
    feePerItem?.get('groupRules')?.markAllAsTouched();
    feePerItem?.get('feeRules')?.markAllAsTouched();
  }

  private findConfigurationError(): string | null {
    let errorMessage: string | null = null;

    // case user select define area and not selected method
    const deliveryAreaDefineCustomValid = this.getField('geoDeliveryAreaMethod').value;
    const deliveryAreaAllValid = this.getField('geoDeliveryArea').value;
    if (deliveryAreaAllValid === false && !deliveryAreaDefineCustomValid) {
      errorMessage = `Please, make sure if you select on location settings define custom delivery area , method is selected`;
    }

    // multi section validation, linked date picker + additional price rules
    const { feePerWeekday, estimatedTimeConversions } = this.formGroup.value;
    if (
      estimatedTimeConversions === 'linked_calendar' &&
      feePerWeekday?.enabled &&
      feePerWeekday?.feePerWeekdayRules?.length &&
      feePerWeekday?.feePerWeekdayRules.some((r) => !!r.shippingName?.trim())
    ) {
      errorMessage = `Invalid configuration - linked calendar cannot be saved with method naming overrides`;
    }

    const signature = this.getField('signatureConfirmation')?.value;
    const signatureValue = this.getField('signatureConfirmationValue')?.value;

    const dryIce = this.getField('dryIce')?.value;
    const dryIceWeightValue = this.getField('dryIceWeight')?.value;

    const insurance = this.getField('insurance')?.value;
    const insuranceAmountValue = this.getField('insuranceAmount')?.value;

    if (signature && signatureValue?.length < 1) {
      errorMessage = 'Attention, signature confirmation is selected, please choose confirmation type';
    }

    if (dryIce && !dryIceWeightValue) {
      errorMessage = 'Attention, dry ice is selected, please choose dry ice weight';
    }

    if (insurance && !insuranceAmountValue) {
      errorMessage = 'Attention, insurance is selected, please choose insurance amount';
    }
    if (this.itemFeeSetupState.setupsPending) {
      errorMessage = 'Saved item fee setups are still loading. Try again in a moment.';
    }

    if (this.itemFeeSetupState.setupsUnavailable) {
      errorMessage =
        'Saved item fee setups could not be loaded, so this method cannot be saved yet. Reload and try again.';
    }

    // Saving now would look like every linked method was updated. While a rule is invalid this advice
    // cannot be followed - "Save Changes" is disabled for that very reason - so the row speaks instead.
    if (this.itemFeeSetupState.hasUnsavedSetupChanges && this.formGroup.controls.feePerItem.valid) {
      errorMessage =
        'You have unsaved changes to the item fee setup. Use "Save Changes" to apply them to every method using it, ' +
        'or "Detach and edit locally" to keep them on this method only.';
    }

    const priceRangeError = this.validatePriceRanges();
    if (priceRangeError) {
      errorMessage = priceRangeError;
    }

    if (this.isInternationalMethod()) {
      const countriesAndRegions = this.formGroup.get('international.countriesAndRegions').value;
      const countryCodes = Object.keys(countriesAndRegions || {});
      errorMessage = countryCodes.length ? errorMessage : 'Please select at least one country in Location Settings';
    }
    return errorMessage;
  }

  private validatePriceRanges(): string | null {
    const ERROR_MESSAGE = 'Minimum price cannot be greater than maximum price';
    const isInvalidRange = (
      min: number | string | null | undefined,
      max: number | string | null | undefined,
    ): boolean => {
      const minValue = Number(min) || 0;
      const maxValue = Number(max);
      return !isNaN(maxValue) && maxValue !== 0 && minValue > maxValue;
    };
    const mainMin = this.formGroup.get('minOrderPriceRange')?.value;
    const mainMax = this.formGroup.get('maxOrderPriceRange')?.value;

    if (isInvalidRange(mainMin, mainMax)) {
      return ERROR_MESSAGE;
    }

    const additionalRanges = this.formGroup.get('additionalPriceRanges') as UntypedFormArray;
    for (let i = 0; i < (additionalRanges?.length ?? 0); i++) {
      const tier = additionalRanges.at(i);
      if (isInvalidRange(tier.get('minOrderPriceRange')?.value, tier.get('maxOrderPriceRange')?.value)) {
        return ERROR_MESSAGE;
      }
    }

    return null;
  }

  onEndAndEditABTest() {
    this.store.dispatch(CheckoutActions.setImmediateActiveShipping({ shipping: this.loadValues }));
    this.editRunningABTest = this.dialog.open(AbtestDialogComponent, {
      data: { mode: ACTIONS.EDIT_RUNNING_ABTEST, testVariant: this.runningABTest },
    });
  }
  listedStatesToListedStatesControl(listedStates: string[]): Record<string, string[]> | null {
    if (!listedStates || listedStates.length === 0) {
      return null;
    }

    const countryCode = this.shopSettings.selectedLocationCountry as keyof typeof extendedCountryToStates;
    const countryStates = extendedCountryToStates[countryCode];

    const result: Record<string, string[]> = {};

    for (const stateName of listedStates) {
      let cleanedName = stateName.trim().replace(/,.*$/i, '').trim();
      if (ABBREVIATION_MAP[cleanedName]) {
        cleanedName = ABBREVIATION_MAP[cleanedName];
      }
      if (TYPO_MAP[cleanedName]) {
        cleanedName = TYPO_MAP[cleanedName];
      }
      const matchingState = (countryStates as Array<{ label: string; value: string }>).find(
        (s) => s.label?.toLowerCase() === cleanedName.toLowerCase(),
      );
      if (matchingState) {
        if (!result[this.shopSettings.selectedLocationCountry]) {
          result[this.shopSettings.selectedLocationCountry] = [];
        }
        if (!result[this.shopSettings.selectedLocationCountry].includes(matchingState.value)) {
          result[this.shopSettings.selectedLocationCountry].push(matchingState.value);
        }
      }
    }

    return result;
  }
  protected readonly OrderEvents = OrderEvents;

  // must not touch the form: the review can still be cancelled
  private forSave(payload: Shippings): Shippings {
    return payload.feePerItem ? { ...payload, feePerItem: feePerItemForSave(payload.feePerItem) } : payload;
  }

  private buildPayload(): Shippings {
    const value = cloneDeep(this.formGroup.value);
    const setIfPresent = (key: string, fieldValue: unknown): void => {
      if (key in value) value[key] = fieldValue;
    };

    value.deliveryDaysAndTimes = [...(value.deliveryDaysAndTimes ?? []), ...this.buildDeliveryDaysAndTimes()];

    const dontCalculateOn: DeliveryPromise[] = value.deliveryPromiseDontCalculateOn ?? [];
    if (dontCalculateOn.length) {
      value.deliveryPromiseDontCalculateOn = this.groupDeliveryPromiseDontCalculateOn(dontCalculateOn);
    }

    if (value.feePerWeekday?.enabled) {
      value.feePerWeekday.feePerWeekdayRules?.forEach((rule) => {
        if (rule.weekday === Checkout.ExtendedWeekdays.DaysAfterHolidays && rule.nationalHolidays) {
          rule.nationalHolidays.holidays = [];
        }
      });
    }

    if (value.feePerItem) {
      value.feePerItem = normaliseFeePerItem(value.feePerItem);
    }

    setIfPresent('deliveryAreaSelectMethod', this.getDeliveryAreaSelectMethod());
    setIfPresent('polygonInputValues', this.buildPolygonInputValues(value.polygonInputValues));
    setIfPresent('deliveryPromiseType', this.checkShippingMethod(this.shippingMethodCategory)?.toLowerCase());

    const disableHolidaysOn = value.deliveryDaysAndTimesHolidays?.value ?? value.deliveryDaysAndTimesHolidays ?? 'none';
    setIfPresent('deliveryDaysAndTimesHolidays', [
      { name: disableHolidaysOn, values: disableHolidaysOn !== 'none' ? [] : 'none' },
    ]);

    const isLocalOrDomestic =
      this.shippingMethodCategory === ShippingMethod.LOCAL || this.shippingMethodCategory === ShippingMethod.DOMESTIC;
    setIfPresent(
      'carrierId',
      isLocalOrDomestic
        ? (value.carrierId?.id ?? this.loadedCarrier?.id ?? value.carrierId)
        : (value.carrierId?.id ?? value.carrierId),
    );

    if (value.polygonInputValues == '') {
      setIfPresent('polygonInputValues', []);
    }

    if (value.estimatedAverageShippingCost === '' || value.estimatedAverageShippingCost === 0) {
      value.estimatedAverageShippingCost = null;
    }

    const { estimatedTimeConversions } = value;
    const timeSettings = value.deliveryPromiseDeliveryTimeSettings;
    if (
      timeSettings &&
      'combineConsecutiveDays' in timeSettings &&
      (this.shippingMethodCategory === ShippingMethod.LOCAL ||
        estimatedTimeConversions === ICheckoutEstimatedTimeConversion.PDQIQ ||
        estimatedTimeConversions === ICheckoutEstimatedTimeConversion.LINKED_CALENDAR)
    ) {
      // not applicable for these methods
      timeSettings.combineConsecutiveDays = false;
    }

    this.nonUseFullControls.forEach((control) => delete value[control]);

    const { maxxAiDeliveryPromiseEnabled, maxxAiDeliveryPromiseMinCap, ...formValues } = value;
    const payload = {
      ...formValues,
      maxxAiConfiguration: {
        maxxAiDeliveryPromiseEnabled: maxxAiDeliveryPromiseEnabled ?? false,
        maxxAiDeliveryPromiseMinCap: maxxAiDeliveryPromiseMinCap ?? null,
      },
      shipmentExtras: cloneDeep(this.shipmentExtrasFormGroup.value),
      conditions: [...this.prepareConditionsToSave(), { ...LOCATIONS_CONDITION, locationValues: [] }],
    };
    const groupId = new URLSearchParams(window.location.search).get('collectionId');
    if (groupId) {
      payload.shippingMethodGroupId = groupId;
    }
    return payload;
  }

  private buildDeliveryDaysAndTimes() {
    const timeValue = (controlName: string) => {
      const control = this.getField(controlName);
      return control ? (control.value?.name ? control.value.name : control.value) : null;
    };

    return this.deliveryDaysNTimeConfig.map((dayNtimes) => ({
      index: dayNtimes.index,
      day: dayNtimes.dayName.toLowerCase(),
      enable: this.getField(dayNtimes.dayName)?.value ?? null,
      fromTime: timeValue(dayNtimes.fromTimeFormControl),
      toTime: timeValue(dayNtimes.toTimeFormControl),
    }));
  }

  // the form keeps one entry per value, the api expects one per type
  private groupDeliveryPromiseDontCalculateOn(entries: DeliveryPromise[]): DeliveryPromise[] {
    const groupedTypes = ['national_holidays', 'weekend_in', 'custom_days', 'weekday_is', 'custom_date'];
    const valuesByType = new Map<string, unknown[]>(groupedTypes.map((type) => [type, []]));

    entries.forEach((entry) => {
      const type = groupedTypes.includes(entry.type) ? entry.type : 'custom_days';
      valuesByType.get(type).push(entry.value);
    });

    return groupedTypes
      .filter((type) => valuesByType.get(type).length)
      .map((type) => {
        const values = valuesByType.get(type);
        if (type !== 'national_holidays') return { type, value: values };
        return { type, value: Object.fromEntries(values.map((country) => [country, []])) };
      }) as DeliveryPromise[];
  }

  private getDeliveryAreaSelectMethod(): string {
    const geoDeliveryArea: boolean | string = this.getField('geoDeliveryArea')?.value;
    if (
      geoDeliveryArea == GEODeliveryArea.COUNTY ||
      geoDeliveryArea == GEODeliveryArea.ZONES ||
      geoDeliveryArea == GEODeliveryArea.ZIP_CODES
    ) {
      return geoDeliveryArea as string;
    }
    return geoDeliveryArea == true ? 'all_cities' : this.getField('geoDeliveryAreaMethod')?.value;
  }

  private buildPolygonInputValues(current: unknown) {
    const locationValues: Record<string, unknown> = {};
    AREA_LIST_FIELDS.forEach((key) => {
      if (this[key]) locationValues[key] = this[key];
    });
    const listedStatesControlValue = this.listedStatesControl.value;
    if (
      listedStatesControlValue &&
      typeof listedStatesControlValue === 'object' &&
      Object.keys(listedStatesControlValue).length > 0
    ) {
      locationValues.listedStatesControl = listedStatesControlValue;
    }
    if (this.shippingMethodCategory == ShippingMethod.LOCAL) {
      locationValues.localMethodCityChoose = this.localMethodCityChoose;
    }

    return cloneDeep([{ ...(Array.isArray(current) ? current[0] : undefined), ...locationValues }]);
  }
}
